module.exports = __webpack_public_path__ + "img/formulation.65cc8693.jpg";